import Linking from 'next/link';
import { MenuItemType } from 'src/types';
import { useUserDataContextProvider } from '../context/UserDataContextProvider';
import { RouteAuthorizer } from '../lib/auth/RouteAuthorizer';
import { jsx as _jsx } from "react/jsx-runtime";

var AuthLinking = function AuthLinking(_ref) {
  var children = _ref.children,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? '' : _ref$link,
      id = _ref.id,
      type = _ref.type,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? 'self' : _ref$target,
      isProtected = _ref.isProtected;

  var _useUserDataContextPr = useUserDataContextProvider(),
      role = _useUserDataContextPr.role;

  var routeAuthorizer = RouteAuthorizer.getInstance();

  if (!routeAuthorizer.checkAuthorized({
    roles: role,
    type: type,
    id: id
  })) {
    return null;
  }

  var isLink = (type === MenuItemType.externalLink || type === MenuItemType.leavesLevel) && !isProtected;
  return isLink ? /*#__PURE__*/_jsx(Linking, {
    target: target,
    href: isLink ? link || id : '',
    e2eid: "components_AuthLinking_Linking",
    children: children
  }) : children;
};

export default AuthLinking;